import { Platform } from '@ionic/angular';
import { Component, ViewChild, Input, Renderer2, AfterViewInit } from '@angular/core';

@Component({
  selector: 'app-canvas-drawings',
  templateUrl: 'canvas-drawings.component.html',
  styleUrls: ['canvas-drawings.component.scss'],
})
export class CanvasDrawingsComponent implements AfterViewInit {

  @ViewChild('canvas') canvas: any;
  @ViewChild('box') box: any;
// tslint:disable-next-line: no-input-rename
  @Input('page') page: string;

  canvasElement: any;
  boxElement: any;
  private _lastX: number;
  private _lastY: number;
  private _margin_iosX: number;
  private _margin_iosY: number;
  private _pressed: boolean;
  private _margin_androidX: number;
  private _margin_androidY: number;
  private _defaultWidthBigScreen = 370;
  private _defaultWidthSmallScreen = 260;
  private _defaultHeightthSmallScreen = 600;
  private _headerAndroid = 56;
  private _headerIos = 44;
  private _widthCalc: number;
  private _heightCalc: number;

  constructor(private _renderer: Renderer2, private _platform: Platform) {
  }

  ngAfterViewInit() {
    this.canvasElement = this.canvas.nativeElement;
    this.boxElement = this.box.nativeElement;

    let boxPlacement = this._platform.height() * 0.5; // Top position of the canvas
    let infoSection = 0; // Info
    const widthC = document.querySelector('.bodyCanvas') as HTMLElement;
    this._widthCalc = widthC.offsetWidth;
    this._heightCalc = widthC.offsetHeight;
    const appW = document.getElementsByClassName('ion-page')[0] as HTMLElement;
    const totalWidth: number = appW.offsetWidth;

    if (this._widthCalc >= this._defaultWidthBigScreen) {
      if (this._heightCalc >= this._defaultHeightthSmallScreen) {
        this._widthCalc = this._defaultWidthBigScreen;
      } else {
        this._widthCalc = this._defaultWidthSmallScreen;
      }
    } else { this._widthCalc = this._defaultWidthSmallScreen; }

    if (document.querySelector('#parent-grid')) {
      if (this._platform.width() > 768) {
        infoSection = 129;
      } else { infoSection = 139; }
    } else if (document.querySelector('#parent-grid-test')) {
      if (this._platform.width() > 768) {
        infoSection = 130 + 5;
      } else { infoSection = 113 + 25; }
    }

    if (this._widthCalc === this._defaultWidthSmallScreen &&
        (this._platform.is('desktop') || this._platform.is('android'))) {
      boxPlacement = boxPlacement + this._headerAndroid;
    } else if (this._widthCalc === this._defaultWidthSmallScreen &&
        (this._platform.is('ios'))) {
      boxPlacement = boxPlacement + this._headerIos;
    }

    this._renderer.setAttribute(this.canvasElement, 'width', this._widthCalc + '');
    this._renderer.setAttribute(this.canvasElement, 'height', this._widthCalc + '');
    this._renderer.setAttribute(this.boxElement, 'height', this._widthCalc + '');
    this._renderer.setAttribute(this.boxElement, 'width', this._widthCalc + '');

    if (this._platform.is('desktop') || this._platform.is('android')) {
      this._margin_androidX = (totalWidth - this._widthCalc) / 2;
      this._margin_androidY = boxPlacement - infoSection;
    } else if (this._platform.is('ios')) {
      this._margin_iosX = (totalWidth - this._widthCalc) / 2;
      this._margin_iosY = boxPlacement - infoSection;
    }
  }

  getPhoto() {
    const photo = document.getElementById('MyCanvas') as HTMLCanvasElement;
    return photo.toDataURL();
  }

  getCanvas() {
    const photo = document.getElementById('MyCanvas') as HTMLCanvasElement;
    const ctx = photo.getContext('2d');
    const data = ctx.getImageData(0, 0, photo.width, photo.height);
    return data;
  }

  evaluationPrompt(ans: string) {
    if (ans === 'good') {
      const elem = document.getElementsByClassName('icon_ans_good')[0] as HTMLElement;
      elem.style.display = 'unset';
    } else if (ans === 'wrong') {
      const elem = document.getElementsByClassName('icon_ans_bad')[0] as HTMLElement;
      elem.style.display = 'unset';
    } else {
      const elem_good = document.getElementsByClassName('icon_ans_good')[0] as HTMLElement;
      const elem_bad = document.getElementsByClassName('icon_ans_bad')[0] as HTMLElement;
      elem_good.style.display = 'none';
      elem_bad.style.display = 'none';
    }
  }

  beginAnim() {
    const parent = document.getElementsByClassName('real_canvas')[0] as HTMLElement;
    const child = document.getElementsByClassName('character')[0] as HTMLElement;
    parent.removeChild(child);
    parent.appendChild(child);
  }

  handleStart(ev) {
    if (this._platform.is('ios')) {
      // iOS --> only header
      this._lastX = ev.touches[0].pageX - this._margin_iosX;
      this._lastY = ev.touches[0].pageY - this._margin_iosY;
    } else if (this._platform.is('android')) {
      // Android --> only header
      this._lastX = ev.touches[0].pageX - this._margin_androidX;
      this._lastY = ev.touches[0].pageY - this._margin_androidY;
    } else {
      this._lastX = ev.pageX - this._margin_androidX;
      this._lastY = ev.pageY - this._margin_androidY;
    }
    this._pressed = true;
  }

  handleStop(ev) {
    this._pressed = false;
  }

  clearCanvas() {
    const canv = document.getElementById('MyCanvas') as HTMLCanvasElement;
    const ctx = canv.getContext('2d');
    ctx.clearRect(0, 0, canv.width, canv.height);
  }

  handleMovement(ev) {
    const ctx = this.canvasElement.getContext('2d');
    let currentX;
    let currentY;

    if (this._platform.is('ios')) {
      // iOS --> only header
      currentX = ev.touches[0].pageX - this._margin_iosX;
      currentY = ev.touches[0].pageY - this._margin_iosY;
    } else if (this._platform.is('android')) {
      // Android --> only header
      currentX = ev.touches[0].pageX - this._margin_androidX;
      currentY = ev.touches[0].pageY - this._margin_androidY;
    } else {
      // PC -> Web browser
      if (this._pressed) {
        currentX = ev.pageX - this._margin_androidX;
        currentY = ev.pageY - this._margin_androidY;
      }
    }

    ctx.beginPath();
    ctx.lineJoin = 'round';
    ctx.moveTo(this._lastX, this._lastY);
    ctx.lineTo(currentX, currentY);
    ctx.closePath();
    ctx.strokeStyle = '#2a2a2a';
    ctx.lineWidth = 11;
    ctx.stroke();

    this._lastX = currentX;
    this._lastY = currentY;
  }

}
